export enum GameCategory {
  BOG,
  Arcade,
  BetOnLottery,
  SportFan,
  Slot,
  TableGames,
  BetShop,
  VirtualGames,
  CryptoGames,
  Bonus,
  Instant,
  TronixZone,
  VirtualSports,
  Predictor,
  NumberGames
};